import { Drawer } from "antd";
import { cloneElement, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AddButton } from "../buttons/AddButton";
import { useAppContext } from "../../context/useAppContext";

export function OnRouteChange(event) {
  // listen to route change events
  const location = useLocation();
  useEffect(() => {
    // close the drawer
    event();
  }, [location]);
}

export const GlobalDrawer = ({ placement, title, width, className }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const { updateContext } = useAppContext();

  const showGlobalDrawer = (data) => {
    setOpen(true);
    setData(data);
  };
  const onCloseGlobalDrawer = () => {
    setOpen(false);
  };

  OnRouteChange(() => {
    if (open) setOpen(false);
  });

  useEffect(() => {
    updateContext("showGlobalDrawer", showGlobalDrawer);
  }, []);

  return (
    <Drawer
      title={data.title}
      placement={placement}
      onClose={onCloseGlobalDrawer}
      width={width || 500}
      open={open}
      // destroyOnClose
    >
      {data?.component && cloneElement(data?.component, { setOpen: setOpen })}
    </Drawer>
  );
};
